import { useContext } from 'react'

import { launchModal } from '@domain-group/javascript-utils'

import PageContext from '@contexts/pageContext'

import type { AttachmentTag, TaskListItemModel } from '@models/types'

import useAttachments from '@hooks/useAttachments'

function useRequestedChanges(taskListItem: TaskListItemModel) {
  const { callbacks } = useContext(PageContext)

  const attachmentsPayload = useAttachments({
    filters: {
      attachable_id: taskListItem.id,
      attachable_type: 'TaskListItem',
      attachment_type: 'tagged_image',
    },
    performHttpRequests: !!taskListItem.id,
    requestOptions: {
      include_attachment_file: true,
    },
  })

  const { filteredAttachments } = attachmentsPayload
  const previewImageAttachment = filteredAttachments[0] || {}

  // @ts-expect-error
  const tags: AttachmentTag[] = previewImageAttachment?.data?.tags ?? []

  return {
    callbacks: {
      viewRequestedChanges: () => launchModal({
        callbacks,
        modalKey: 'ViewRequestedChangesModal',
        payload: {
          attachment: previewImageAttachment,
        },
      }),
    },
    tags,
  }
}

export default useRequestedChanges
